import { axiosService } from "./axios.service";

export class IdentityTheftCheckerService {
  static getHibpData = async (email: string): Promise<string> => {
    const response: string = await axiosService.get(`/webhook/hibp/${email}`);
    return response;
  };
}
